"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopPageFrame = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Navigation_1 = require("../Navigation");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const WebChatUpsellToast_1 = require("../WebChatUpsellToast");
const CommonPageFrame_module_css_1 = __importDefault(require("./CommonPageFrame.module.css"));
const CTAFooter_1 = require("../CTAFooter");
const PAGE_TYPES_WITHOUT_WEBCHAT_UPSELL = [
    web_blizzard_reporting_1.PageType.SNAPCHAT_HOME_PAGE,
    web_blizzard_reporting_1.PageType.DOWNLOAD_PAGE,
    web_blizzard_reporting_1.PageType.VOTE,
    web_blizzard_reporting_1.PageType.JOIN_COMMUNITY,
];
/**
 * Desktop Page Frame Component
 */
function DesktopPageFrame({ children, webClientId, locale, messages, localeChange, downloadUrl, navigationProps, footerProps, hideDefaultFooter, pageType, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Navigation_1.DesktopNavigation, { ...navigationProps, locale: locale, messages: messages, localeChange: localeChange, webClientId: webClientId, pageType: pageType, downloadUrl: downloadUrl }), children, !PAGE_TYPES_WITHOUT_WEBCHAT_UPSELL.includes(pageType) && ((0, jsx_runtime_1.jsx)(WebChatUpsellToast_1.WebChatUpsellToast, { pageType: pageType, locale: locale })), (0, jsx_runtime_1.jsx)("div", { className: CommonPageFrame_module_css_1.default.footerWrapper, children: hideDefaultFooter ? null : ((0, jsx_runtime_1.jsx)(CTAFooter_1.CTAFooter, { ...(footerProps ?? {}), locale: locale, downloadUrl: downloadUrl, localeChange: localeChange, webClientId: webClientId, pageType: pageType })) })] }));
}
exports.DesktopPageFrame = DesktopPageFrame;
//# sourceMappingURL=DesktopPageFrame.js.map